<template>
    <Header></Header>
    <div class="container">
        <template v-for="sector in mainSectorList.list">
            <template v-if="sector.key === 'banner'">
                <section class="main_slide_wrap">
                    <div class="main_slide">
                        <swiper
                            ref="swiperRef"
                            v-if="bannerList.list.length > 0"
                            :space-between="5"
                            :loop="true"
                            @swiper="onSwiper"
                            @slideChange="onSlideChange"
                            style="height: 100%"
                        >
                            <swiper-slide class="img_wrap" v-for="(item, idx) in bannerList.list" :key="idx">
                                <a :href="item.link" v-if="item.link">
                                    <img :src="isPc ? item.fileMobile : item.file" alt="" @error="imgError" />
                                </a>
                                <img v-else :src="isPc ? item.fileMobile : item.file" alt="" @error="imgError" />
                            </swiper-slide>
                        </swiper>

                        <div class="btn_wrap _slide">
                            <button class="prev_btn" @click="prevSlide"><img src="img/next_btn.png" alt="" /></button>
                            <button class="next_btn" @click="nextSlide"><img src="img/next_btn.png" alt="" /></button>
                        </div>
                    </div>
                </section>
            </template>
            <template v-else-if="sector.key === 'statics'">
                <section class="main_01">
                    <div class="main_bg_wrap">
                        <i class="deco_01 _large blink_zoom3"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_02 _medium blink_zoom1"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_03 _xlarge blink_zoom3"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_04 _medium spin_blink3"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_05 _large blink_blink2"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_06 _medium spin_blink2"><img src="img/bg_deco_01.png" alt="" /></i>

                        <i class="deco_main_01"><img src="img/main_01_deco_01.png" alt="" /></i>
                        <i class="deco_main_02"><img src="img/main_01_deco_02.png" alt="" /></i>
                        <i class="deco_main_03"><img src="img/main_01_deco_03.png" alt="" /></i>
                        <i class="deco_main_04"><img src="img/main_01_deco_04.png" alt="" /></i>
                        <i class="deco_main_05"><img src="img/main_01_deco_05.png" alt="" /></i>
                    </div>
                    <div class="wrap_1330">
                        <div class="tit_wrap">
                            <p>시민과 함께한 불법산업 감시 행동</p>
                            <h2>시민과 함께 만든 변화</h2>
                        </div>
                        <div class="circle_wrap">
                            <div class="circle">
                                <span class="icon_wrap"><img src="img/main_01_icon_01.png" alt="" /></span>
                                <div class="num_count_wrap">
                                    <div class="num_count" :data-count="state.cnt_report">{{ state.cnt_report }}건</div>
                                </div>
                                <p>전체 시민제보</p>
                            </div>
                            <div class="circle">
                                <span class="icon_wrap"><img src="img/main_01_icon_03.png" alt="" /></span>
                                <div class="num_count_wrap">
                                    <div class="num_count" :data-count="state.cnt_citizen_report">{{ state.cnt_citizen_report }}건</div>
                                </div>
                                <p>신고/고발</p>
                            </div>
                            <div class="circle">
                                <span class="icon_wrap"><img src="img/main_01_icon_02.png" alt="" /></span>
                                <div class="num_count_wrap">
                                    <div class="num_count" :data-count="state.cnt_citizen">{{ state.cnt_citizen }}명</div>
                                </div>
                                <p>함께한 시민 수</p>
                            </div>
                        </div>
                        <p class="areaDateMain">*{{ CommonUtils.dateFormatYYYYMM(new Date(state.date_main), ".") }} 기준</p>
                    </div>
                </section>
            </template>

            <template v-else-if="sector.key === 'ad'">
                <section class="main_02">
                    <div class="wrap_1700">
                        <div class="tit_wrap _white">
                            <h2>
                                일상에서 성매매 업소,
                                <br class="only_640" />
                                성매매 알선 광고를
                                <br />
                                발견하셨다면 제보해주세요!
                            </h2>
                            <p>*회원가입 없이 익명으로 제보 가능</p>
                        </div>
                        <div class="con_wrap">
                            <div class="con">
                                <p>성매매 의심업소</p>

                                <router-link to="/areaWrite">
                                    <span>제보하기</span>
                                    <img src="img/move_btn.png" alt="" />
                                </router-link>
                            </div>
                            <div class="con">
                                <p>성매매 알선 광고</p>
                                <router-link to="/adWrite">
                                    <span>제보하기</span>
                                    <img src="img/move_btn.png" alt="" />
                                </router-link>
                            </div>
                            <div class="con">
                                <p>시민제보 처리과정이 궁금하신가요?</p>
                                <router-link to="/faqView/27">
                                    <span>알아보기</span>
                                    <img src="img/move_btn.png" alt="" />
                                </router-link>
                            </div>
                        </div>
                    </div>
                </section>
            </template>

            <template v-else-if="sector.key === 'board_entire'">
                <section class="main_03">
                    <div class="main_bg_wrap">
                        <i class="deco_01 _medium blink_zoom2"><img src="img/bg_deco_04.png" alt="" /></i>
                        <i class="deco_02 _medium blink_zoom4"><img src="img/bg_deco_04.png" alt="" /></i>
                        <i class="deco_03 _xxlarge spin_blink2"><img src="img/bg_deco_03.png" alt="" /></i>

                        <i class="deco_main_01"><img src="img/main_03_deco_01.png" alt="" /></i>
                        <i class="deco_main_02"><img src="img/main_03_deco_02.png" alt="" /></i>
                        <i class="deco_main_03"><img src="img/main_03_deco_03.png" alt="" /></i>
                        <i class="deco_main_04 float2"><img src="img/main_03_deco_04.png" alt="" /></i>
                        <i class="deco_main_05"><img src="img/main_03_deco_05.png" alt="" /></i>
                        <i class="deco_main_06 float1"><img src="img/main_03_deco_06.png" alt="" /></i>
                    </div>
                    <div class="tit_wrap">
                        <span class="icon_wrap"><img src="img/main_03_icon.png" alt="" /></span>
                        <p>지금 참여할 수 있는 반성매매 활동</p>
                        <h2>우리 함께 참여해요!</h2>
                    </div>
                    <!-- 우리 함께 참여해요 -->
                    <div class="main_03_slide_wrap">
                        <div class="btn_wrap _slide">
                            <button class="prev_btn"><img src="img/next_btn.png" alt="" /></button>
                            <button class="next_btn"><img src="img/next_btn.png" alt="" /></button>
                        </div>

                        <div class="main_03_slide">
                            <swiper
                                v-if="boardList.list.length > 0"
                                class="swiper-wrapper"
                                :modules="modules"
                                :loop="true"
                                :centered-slides="true"
                                :slides-per-view="1.7"
                                :speed="400"
                                :navigation="{
                                    prevEl: '.main_03_slide_wrap .prev_btn',
                                    nextEl: '.main_03_slide_wrap .next_btn',
                                }"
                                :breakpoints="{
                                    641: { slidesPerView: 3, centeredSlides: true },
                                    1024: { slidesPerView: 5 },
                                }"
                            >
                                <swiper-slide class="swiper-slide" v-for="(item, idx) in boardList.list" :key="idx" @click="moveBoard(item)">
                                    <span class="img_wrap">
                                        <img :src="item.fileList[0].file" @error="imgError" v-if="item.fileList && item.fileList.length > 0" />
                                    </span>
                                    <span v-if="item.type === 1">반성매매 시민활동</span>
                                    <span v-if="item.type === 2">캠페인·이벤트</span>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                </section>
            </template>

            <template v-else-if="sector.key === 'board_news'">
                <section class="main_04">
                    <div class="main_bg_wrap">
                        <i class="deco_03"><img src="img/main_04_deco_02.png" alt="" /></i>
                        <i class="deco_04"><img src="img/main_04_deco_03.png" alt="" /></i>
                    </div>
                    <div class="tit_wrap _white">
                        <div class="main_bg_wrap">
                            <i class="deco_01"><img src="img/main_04_deco_01.png" alt="" /></i>
                            <i class="deco_02"><img src="img/main_04_deco_04.png" alt="" /></i>
                        </div>
                        <span class="icon_wrap"><img src="img/main_04_icon.png" alt="" /></span>
                        <p>
                            다시함께상담센터의 불법성산업
                            <br class="none_1240" />
                            감시 소식을 확인하세요
                        </p>
                        <h2>감시소식</h2>
                        <router-link to="/news" class="more_btn" style="z-index: 1">
                            더보기
                            <img src="img/more_btn.png" alt="" />
                        </router-link>
                    </div>

                    <div class="con_wrap main_04_slide">
                        <swiper
                            class="swiper-wrapper"
                            :modules="modules"
                            :loop="false"
                            :slide-to-clicked-slide="false"
                            :centered-slides="true"
                            :slides-per-view="1.02"
                            :breakpoints="{
                                640: { slidesPerView: 2.2, spaceBetween: 20, centeredSlides: false },
                                768: { slidesPerView: 3.2, spaceBetween: 20, centeredSlides: false },
                                1024: { slidesPerView: 4, spaceBetween: 30, centeredSlides: false },
                            }"
                        >
                            <swiper-slide class="img_wrap swiper-slide" v-for="(item, idx) in gamsiList.list" :key="idx">
                                <router-link :to="{ name: 'NewsView', params: { id: item.idx } }">
                                    <img :src="item.fileList[0].file" @error="imgError" v-if="item.fileList && item.fileList.length > 0" />
                                    <img :src="item.fileList" @error="imgError" v-else />
                                </router-link>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
            </template>

            <template v-else-if="sector.key === 'subscribe'">
                <section class="main_05">
                    <div class="main_bg_wrap">
                        <i class="deco_01 _large _white spin_blink3"><img src="img/bg_deco_03.png" alt="" /></i>
                        <i class="deco_02 _small blink_blink3"><img src="img/bg_deco_04.png" alt="" /></i>
                        <i class="deco_03 _xsmall _white blink_blink2"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_04 _xsmall _white"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_05 _small _white spin_blink3"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_06 _small _white blink_zoom3"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_07 _small _white"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_08 _small"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_09 _medium spin_blink2"><img src="img/bg_deco_03.png" alt="" /></i>
                        <i class="deco_10 _medium"><img src="img/bg_deco_06.png" alt="" /></i>
                        <i class="deco_11 _xlarge"><img src="img/bg_deco_07.png" alt="" /></i>

                        <i class="deco_12 _small _white spin_blink2"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_13 _medium _white"><img src="img/bg_deco_03.png" alt="" /></i>
                        <i class="deco_14 _xxsmall _white blink4"><img src="img/bg_deco_05.png" alt="" /></i>
                        <i class="deco_15 _medium _white spin_blink3"><img src="img/bg_deco_01.png" alt="" /></i>
                        <i class="deco_16 _small blink_zoom4"><img src="img/bg_deco_03.png" alt="" /></i>
                        <i class="deco_17 _small _white"><img src="img/bg_deco_02.png" alt="" /></i>
                        <i class="deco_18 _xsmall _white blink_blink4"><img src="img/bg_deco_05.png" alt="" /></i>
                        <i class="deco_19 _xxsmall blink3"><img src="img/bg_deco_05.png" alt="" /></i>

                        <i class="deco_main_01"><img src="img/main_05_deco_01.png" alt="" /></i>
                        <i class="deco_main_02"><img src="img/main_05_deco_02.png" alt="" /></i>
                    </div>
                    <div class="wrap_1500">
                        <div class="tit_wrap _white">
                            <p>다시함께의 다양한 성매매 방지 활동 소식이 궁금하시다면?</p>
                            <h2 class="areaNewsTitle">
                                <span style="margin-bottom: 20px">
                                    다시함께상담센터
                                    <br />
                                    뉴스레터 구독하기
                                </span>
                                <a href="https://dasihamkke.stibee.com/" class="submit_btn areaNewsLink" style="">
                                    센터의 이전 활동들을 확인해보세요!
                                    <img src="img/move_btn.png" alt="" />
                                </a>
                            </h2>
                        </div>
                        <div class="form_wrap">
                            <div class="form_con">
                                <input class="input_default name_wrap" type="text" v-model="subscribe_state.name" placeholder="이름" />
                                <div class="email_wrap input_default">
                                    <input type="text" v-model="subscribe_state.emailId" placeholder="이메일" />
                                    <span>@</span>

                                    <div class="select_tab_box" v-if="!state.isDirect && state.select_domain !== '직접입력'">
                                        <div class="selected_tab" :class="[state.isActive ? 'active' : '']" @click="state.isActive = !state.isActive">
                                            <span>{{ state.select_domain }}</span>
                                        </div>
                                        <div class="tab_option">
                                            <button
                                                v-for="(value, idx) in email_domain_list"
                                                :key="idx"
                                                @click="
                                                    subscribe_state.emailDomain = value;
                                                    state.email_domain = value;
                                                    state.isActive = false;
                                                    state.select_domain = value;
                                                    state.isDirect = false;
                                                "
                                                :class="[state.email_domain === value ? 'active' : '']"
                                            >
                                                {{ value }}
                                            </button>

                                            <button
                                                class="self"
                                                @click="
                                                    state.email_domain = '';
                                                    state.isActive = false;
                                                    state.select_domain = '직접입력';
                                                    state.isDirect = true;
                                                    subscribe_state.emailDomain = '';
                                                "
                                            >
                                                직접입력
                                            </button>
                                        </div>
                                    </div>

                                    <div class="self_wrap" v-else style="display: block">
                                        <input type="text" class="" v-model="subscribe_state.emailDomain" placeholder="직접입력" />
                                        <button
                                            @click="
                                                state.isDirect = false;
                                                state.select_domain = state.email_domain = subscribe_state.emailDomain = email_domain_list[0];
                                            "
                                        >
                                            <img src="img/erase.png" alt="" />
                                        </button>
                                    </div>
                                </div>
                                <label class="agree_wrap" for="privacy">
                                    <input type="checkbox" id="privacy" v-model="subscribe_state.isAgree" />
                                    <em></em>
                                    <p>개인정보 수집 및 이용에 동의합니다.</p>
                                </label>
                            </div>
                            <button class="submit_btn" @click="subscribe" style="margin-bottom: 39px">구독하기</button>
                        </div>
                    </div>
                </section>
            </template>
        </template>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <template v-if="popupBannerList && popupBannerList.list.length > 0">
        <div class="pop_banner_wrap">
            <ModalPopup v-for="item in popupBannerList.list" :key="item.idx" :item="item"></ModalPopup>
        </div>
    </template>
    <Footer></Footer>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Footer,
        ModalDefault,
        ModalPopup,
        types,
        Swiper,
        SwiperSlide,
        useSwiper,
        Navigation,
        FreeMode,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        onUnmounted,
        computed,
        CommonUtils,
    } from "@/BaseComponent";
    import { List } from "echarts";

    export default {
        props: {},
        components: { Header, Footer, ModalDefault, ModalPopup, Swiper, SwiperSlide },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const windowWidth = ref(window.innerWidth);
            const handleResize = () => {
                windowWidth.value = window.innerWidth;
            };

            const email_domain_list = ["naver.com", "gmail.com", "daum.net"];
            const state = reactive({
                navIsOpen: true,
                cnt_citizen: 0 as number,
                cnt_citizen_report: 0 as number,
                cnt_report: 0 as number,
                date_main: "" as string,

                email: "",
                email_domain: "",
                select_domain: email_domain_list[0],
                isActive: false as boolean,
                isDirect: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const bannerList = reactive({
                list: [] as Array<types.ResBannerVOForApi>,
                // fileList: [] as any,
            });

            const mainSectorList = reactive({
                list: [] as Array<types.MainSectorForApi>,
            });

            const popupBannerList = reactive({
                list: [] as Array<types.ResPopupBannerVOForApi>,
                // fileList: [] as any,
            });

            const boardList = reactive({
                list: [] as Array<types.ResBoardVOForApi>,
                fileList: [] as any,
            });

            const gamsiList = reactive({
                list: [] as any,
                fileList: [] as any,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            const subscribe_state = reactive({
                name: "",
                emailId: "",
                emailDomain: "naver.com",
                isAgree: false,
            });

            onMounted(() => {
                window.addEventListener("resize", handleResize);

                global.$reset();
                getMainSector();
                getBannerList();
                getPopupBannerList();
                getBoardList();
                getGamsiList();

                setTimeout(() => {
                    window.addEventListener("scroll", handleScroll);
                    handleScroll();
                }, 1000);

                trackDailyVisit();
            });

            onUnmounted(() => {
                window.removeEventListener("resize", handleResize);
            });

            onBeforeUnmount(() => {
                window.removeEventListener("scroll", handleScroll);
            });

            const isPc = computed(() => windowWidth.value <= 1024);

            watch(global, () => {
                state.cnt_citizen = global.cnt_citizen;
                state.cnt_citizen_report = global.cnt_citizen_report;
                state.cnt_report = global.cnt_report;
                state.date_main = global.date_main;
            });

            watch(popup, () => {
                if (popup.list) popupBannerList.list = popup.getVisiblePopups();
            });

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {};

            const subscribe = async () => {
                if (!subscribe_state.name) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "이름을 입력해 주세요.";
                    state.isShowModal = true;
                } else if (!subscribe_state.emailId || !subscribe_state.emailDomain) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "이메일을 입력해 주세요.";
                    state.isShowModal = true;
                } else if (!subscribe_state.isAgree) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "개인정보 동의가 필요합니다.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqSubscribe = {
                        name: subscribe_state.name,
                        email: subscribe_state.emailId + "@" + subscribe_state.emailDomain,
                    };
                    let res: types.BaseResponse = await apiService.base.subscribe(param);
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = "구독이 완료되었습니다.";
                        state.isShowModal = true;

                        subscribe_state.name = "";
                        subscribe_state.emailId = "";
                        subscribe_state.emailDomain = "";
                        subscribe_state.isAgree = false;
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const getMainSector = async () => {
                const res: types.ResMainSector = await apiService.base.mainSector();
                if (res.returnCode === 0) {
                    mainSectorList.list = res.list;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getBannerList = async () => {
                try {
                    const res: types.ResBanner = await apiService.base.getBannerList();
                    if (res.returnCode === 0) {
                        bannerList.list = res.data;
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            const getPopupBannerList = async () => {
                try {
                    const res: types.ResPopupBanner = await apiService.base.getPopupBannerList();
                    if (res.returnCode === 0) {
                        popup.setList(res.data);
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error(err);
                }
            };

            const getBoardList = async () => {
                try {
                    const res: types.ResBoardForMain = await apiService.base.civicEngagement();
                    if (res.returnCode === 0) {
                        const list: types.ResBoardVOForApi[] = res.data;

                        if (list.length < 10) {
                            list.forEach((item: types.ResBoardVOForApi) => {
                                boardList.list.push(item);
                            });

                            list.forEach((item: types.ResBoardVOForApi) => {
                                boardList.list.push(item);
                            });
                        } else {
                            boardList.list = list;
                        }
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            const getGamsiList = async () => {
                try {
                    const res: types.ResBoardForMain = await apiService.base.monitoringNews();
                    if (res.returnCode === 0) {
                        gamsiList.list = res.data;
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            const swiperRef = ref<any>(null);

            const nextSlide = () => {
                swiperRef.value.slideNext();
            };

            const prevSlide = () => {
                swiperRef.value.slidePrev();
            };

            const onSwiper = (swiper: any) => {
                swiperRef.value = swiper;
            };

            const onSlideChange = () => {};

            const moveBoard = (item: any) => {
                switch (item.type) {
                    case 1:
                        router.push({ name: "ActivityView", params: { id: item.idx } });
                        break;
                    case 2:
                        router.push({ name: "EventView", params: { id: item.idx } });
                        break;
                }
            };

            const countUp = (counter: HTMLElement, targetNum: number, duration = 1500, idx: number) => {
                const startTime = performance.now();

                const easeOutCubic = (t: number): number => {
                    return 1 - Math.pow(1 - t, 3);
                };

                const update = (currentTime: number) => {
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const easedProgress = easeOutCubic(progress);

                    const currentValue = Math.floor(targetNum * easedProgress);
                    counter.textContent = currentValue.toLocaleString();

                    if (progress < 1) {
                        requestAnimationFrame(update);
                    } else {
                        if (idx < 2) counter.textContent = targetNum.toLocaleString() + "건";
                        else counter.textContent = targetNum.toLocaleString() + "명";
                    }
                };

                requestAnimationFrame(update);
            };

            const isInViewport = (el: HTMLElement): boolean => {
                const rect = el.getBoundingClientRect();
                return rect.top < window.innerHeight && rect.bottom > 0;
            };

            const handleScroll = () => {
                const counters = document.querySelectorAll<HTMLElement>(".num_count");
                counters.forEach((counter, idx) => {
                    if (counter.dataset.animated) return;
                    if (!isInViewport(counter)) return;
                    counter.dataset.animated = "true";
                    const targetNum = Number(counter.getAttribute("data-count"));
                    countUp(counter, targetNum, 1500, idx);
                });
            };

            const trackDailyVisit = async () => {
                const today = CommonUtils.getToday();
                const visitKey = "lastVisitDate";

                const lastVisit = localStorage.getItem(visitKey);

                if (lastVisit !== today) {
                    // 오늘 첫 방문일 경우에만 서버에 알림
                    localStorage.setItem(visitKey, today);
                    const res = await apiService.base.visit();
                    if (res.returnCode !== 0) {
                        console.error(res.description);
                    }
                }
            };

            return {
                state,
                user,
                email_domain_list,
                router,
                subscribe_state,
                subscribe,
                closeModal,
                callBackModal,
                mainSectorList,
                bannerList,
                popupBannerList,
                boardList,
                gamsiList,
                imgError,
                onSwiper,
                onSlideChange,
                nextSlide,
                prevSlide,
                types,
                modules: [FreeMode, Navigation],
                global,
                moveBoard,
                popup,
                isPc,
                CommonUtils,
            };
        },
    };
</script>

<style scoped>
    .main_03_slide div.swiper-slide {
        display: inline-flex;
        flex-direction: column;
        width: 30%;
        transform: scale(0.7);
        transition: 0.3s;
        padding-top: 10px;
        cursor: pointer;
        opacity: 0.7;
        filter: blur(0.5px);
    }

    .main_03_slide div.swiper-slide:hover .img_wrap img {
        box-shadow: 0px 0px 10px #00000070;
        transition: 0.3s;
    }

    .main_03_slide div.swiper-slide:where(.swiper-slide-prev, .swiper-slide-next) {
        transform: scale(0.85);
        transition: 0.3s;
    }

    .main_03_slide div.swiper-slide.swiper-slide-prev {
        margin-right: 30px;
        opacity: 0.9;
        filter: blur(0);
    }

    .main_03_slide div.swiper-slide.swiper-slide-next {
        margin-left: 30px;
        opacity: 0.9;
        filter: blur(0);
    }

    .main_03_slide div.swiper-slide:where(.swiper-slide-active) {
        transform: scale(1);
        transition: 0.3s;
        filter: blur(0);
        opacity: 1;
    }

    p.areaDateMain {
        font-family: Noto Sans KR;
        font-weight: 400;
        font-style: Regular;
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0%;
        text-align: right;

        color: #6d6d6d;
        margin-top: 20px;
        margin-right: 20px;
        width: 100%;
    }

    a.areaNewsLink {
        padding: 20px;
        font-size: 16px;
        line-height: initial;
        height: auto;
        width: 350px;
        display: flex;
        justify-content: center;
    }

    h2.areaNewsTitle {
        display: flex;
        flex-direction: column;
    }

    h2 :where(img) {
        width: 20px;
        height: 23px;
        object-fit: contain;
        transition: 0.2s ease-in-out;
        margin-left: 10px;
    }
    .email_wrap .self_wrap input {
        padding-left: 25px;
    }

    @media (max-width: 768px) {
        h2 {
            align-items: center;
        }

        h2 :where(img) {
            width: 20px;
            height: 23px;
            object-fit: contain;
            transition: 0.2s ease-in-out;
        }
    }
</style>
